module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("These essays are dedicated to the students, faculty, and institutions who heard much of this material over the past fifteen years. I am grateful for the opportunities I have had to learn from all of you, and to know of the great work these schools continue to do in building up the Asian church.")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Trinity Theological College, Republic of Singapore")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("TCA College, Republic of Singapore")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Sabah Theological Seminary, Kota Kinabalu, Sabah, Malaysia")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Presbyterian University and Theological Seminary, Seoul, South Korea")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Yonsei University, Seoul, South Korea")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("McGilvery Faculty of Theology at Payap University, Chiang Mai, Thailand")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Nanjing Union Theological Seminary, Nanjing, China")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Shandong Theological Seminary, Jinan, China")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Colombo Theological Seminary, Colombo, Sri Lanka")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Myanmar Institute of Theology, Insein, Yangon, Myanmar ")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7caf7b7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03dedication.vue
// module id = 60
// module chunks = 0